import { render, staticRenderFns } from "./NutritionRawNeedModal.vue?vue&type=template&id=df5f6bf8"
import script from "./NutritionRawNeedModal.vue?vue&type=script&lang=js"
export * from "./NutritionRawNeedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports